import { render, staticRenderFns } from "./imgupload.vue?vue&type=template&id=6adf73b3&scoped=true&"
import script from "./imgupload.vue?vue&type=script&lang=js&"
export * from "./imgupload.vue?vue&type=script&lang=js&"
import style0 from "./imgupload.vue?vue&type=style&index=0&id=6adf73b3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6adf73b3",
  null
  
)

export default component.exports